module.exports = __webpack_public_path__ + "static/media/support.8698d92a.svg";